import { useEffect, useState, useCallback } from "react";
import copy from "../../assets/image/copy-icon.webp";
// import Inputeffect from "../../assets/image/input-effect.webp";
import { useNavigate } from "react-router-dom";
import useApi from "../../hooks/useApi";
import { GET_ADVOCATE_LIST } from "../../utils/apiConstants";
import paths from "../../utils/paths";
import AdvocateCard from "../../components/Common/AdvocateCard";
import { Grid } from "@mui/material";
import styles from "./landingPage.module.css";

function Panel() {
  const navigate = useNavigate();
  const { apiRequest } = useApi();

  const [ArbitratorList, setArbitratorList] = useState([]);

  const getLawerdetails = useCallback(async () => {
    try {
      const response = await apiRequest({
        url: GET_ADVOCATE_LIST,
        method: "post",
      });
      setArbitratorList(response?.data?.advocates);
    } catch (error) {
      console.log("error in getting advocateList :", error);
    }
  }, [apiRequest]);

  useEffect(() => {
    getLawerdetails();
  }, [getLawerdetails]);

  const navigateto = () => {
    window.open(
      `https://xdc.network/token/xdc05940b2df33d6371201e7ae099ced4c363855dfe`,
      "_blank"
    );
  };
  return (
    <div>
      <div className="px-3">
        <div className={styles.addressContent}>
          <h2>LBT Smart Contract Address</h2>
          <div className="address-input" onClick={navigateto}>
            <input
              type="text"
              placeholder="xdc05940b2df33d6371201e7ae099ced4c363855dfe"
              readOnly
              className="bg-white w-100"
            />
            <div className="copy-icons">
              <img src={copy} alt="icon" />
            </div>
          </div>
          {/* BACKGROUND EFFECT */}
          {/* <div className="input-effect">
            <img src={Inputeffect} alt="effect" />
          </div> */}
          <div
            className={`${styles.panel_content} ${styles.panel_content1} d-flex justify-content-center`}
          >
            <div className={`${styles.panel_w}`}>
              <h2 className="text-center">Legal panel</h2>
              <p className="text-center w-100 mx-auto">
                Explore our team of experienced attorneys with expertise in
                various legal domains. We connect you with trusted professionals
                to provide reliable advice and effective solutions tailored to
                your needs.
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex flex-col justify-content-center">
          <Grid container spacing={2}>
            {ArbitratorList.slice(0, 8).map((data, i) => (
              <Grid size={{ xs: 6, sm: 4, lg: 3 }} key={data.id}>
                <AdvocateCard
                  advocateId={data.id}
                  profileImg={data?.prfileIMG}
                  fullName={data.fullName}
                  email={data?.email}
                  experience={data?.Experience}
                  country={data?.country}
                />
              </Grid>
            ))}
          </Grid>
          <div className="mt-5 d-flex justify-content-center">
            <button
              className="gradientButton fw-bold rounded py-2 px-3"
              onClick={() => navigate(paths.Arbitrators)}
            >
              View more
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Panel;
